type Notice = {
  message: string;
};

export const honeyBadgerConfig = {
  apiKey: import.meta.env.VITE_APP_HONEYBADGER_KEY,
  environment: import.meta.env.VITE_APP_HONEYBADGER_ENV,
  revision: import.meta.env.VITE_APP_HONEYBADGER_REVISION,
  ignoreBrowserExtensionErrors: true
};

const ignoredNoticeMessages = [
  'Failed to load https://www.googletagmanager.com/gtag/js',
  'Promise.withResolvers is not a function'
];

const isGoogleFedCmUpdateError = (notice: Notice): boolean =>
  notice.message.includes('UnhandledPromiseRejectionWarning: Object Not Found Matching Id:') &&
  notice.message.includes('MethodName:update, ParamCount:4');

// return false if you don't want the error to be reported
export const filterHoneybadgerNotices = (notice: Notice | undefined): boolean => {
  if (!notice) return true;

  if (isGoogleFedCmUpdateError(notice)) return false;

  return !ignoredNoticeMessages.some(message => notice.message.includes(message));
};
